jQuery( function($) {
  $(document).ready(function() {
      $('.urban-testimonial-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: '.urban-testimonial-bg',
        autoplay: true,
        autoplaySpeed: 3000,
     });

     $('.urban-testimonial-bg').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.urban-testimonial-slider',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
     });

     // Remove active class from all thumbnail slides
     $('.urban-testimonial-bg .slick-slide').removeClass('slick-active');

     // Set active class to first thumbnail slides
     $('.urban-testimonial-bg .slick-slide').eq(0).addClass('slick-active');

     // On before slide change match active thumbnail to current slide
     $('.urban-testimonial-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var mySlideNumber = nextSlide;
        $('.urban-testimonial-bg .slick-slide').removeClass('slick-active');
        $('.urban-testimonial-bg .slick-slide').eq(mySlideNumber).addClass('slick-active');
    });

    function initializeSlickSlider() {
        if ($(window).width() < 768) {
            if (!$('.urban-sec8 .multi-column').hasClass('slick-initialized')) {
                $('.urban-sec8 .multi-column').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                });
            }
        } else {
            if ($('.urban-sec8 .multi-column').hasClass('slick-initialized')) {
                $('.urban-sec8 .multi-column').slick('unslick');
            }
        }
    }
    // Initialize on load
    initializeSlickSlider();
    // Re-initialize on window resize
    $(window).on('resize', function() {
        initializeSlickSlider();
    });  
    
  });
});

var target_date = new Date("October 7, 2024 23:59:00").getTime(); // Set the countdown date to October 6 at 11:59 PM
var days, hours, minutes, seconds; // variables for time units

var countdown = document.getElementById("tiles"); // get tag element

getCountdown();

setInterval(function () { getCountdown(); }, 1000);

function getCountdown(){

	// find the amount of "seconds" between now and target
	var current_date = new Date().getTime();
	var seconds_left = (target_date - current_date) / 1000;

	days = pad( parseInt(seconds_left / 86400) );
	seconds_left = seconds_left % 86400;
		 
	hours = pad( parseInt(seconds_left / 3600) );
	seconds_left = seconds_left % 3600;
		  
	minutes = pad( parseInt(seconds_left / 60) );
	seconds = pad( parseInt( seconds_left % 60 ) );

	// format countdown string + set tag value
	try {
      countdown.innerHTML = "<span>" + days + "</span><span>" + hours + "</span><span>" + minutes + "</span><span>" + seconds + "</span>";
    } catch (error) {
      //console.log("Error updating countdown:", error);
    }

}

function pad(n) {
	return (n < 10 ? '0' : '') + n;
}
// if (window.location.pathname == "/pages/unicorn-series" || window.location.pathname == '/pages/kerrie-sttrap-series' || window.location.pathname == '/pages/kerrie-sttrap-forrest-saffron') {
//     var sections = document.querySelectorAll('.shopify-section--featured-product');
//     sections.forEach((elem) => {

//       var salePriceElements = elem.querySelector('.product-info .product-info__price sale-price.text-lg');
//       var buttonTextDivs = elem.querySelector('.product-info__buy-buttons .buy-buttons .button div');
//         if(buttonTextDivs.innerHTML == 'Add to cart'){
          
//             var salePriceTexts = salePriceElements.textContent.trim().replace('Sale price', '').replace('USD', '').trim();
//             buttonTextDivs.innerHTML = `ADD TO CART - ${salePriceTexts} USD`;
//         }
//       });
//  }
if (window.location.pathname == '/pages/kerrie-sttrap-series') {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.shopify-section--featured-product').forEach(elem => {
        var checkedInput = elem.querySelector('input[data-option-position="1"][checked]');
        var imgSrcs = checkedInput ? checkedInput.getAttribute('data-var-img') : null;


        if (imgSrcs) {
            var thumbnailss = elem.querySelectorAll('.product-gallery__thumbnail img');

            thumbnailss.forEach(function(thumbnail) {
                if (thumbnail.src.includes(imgSrcs)) {
                    var parentThumbnails = thumbnail.closest('.product-gallery__thumbnail');
                    
                    if (parentThumbnails) {
                        parentThumbnails.click();
                    }
                }
            });
        }
    });
  });

  document.querySelectorAll('.product-gallery').forEach(elem => {
      
  var thumbnails = elem.querySelectorAll('.product-gallery__thumbnail');
  var mediaItems = elem.querySelectorAll('.product-gallery__media');
  
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function() {
     
      mediaItems.forEach(media => {
        media.classList.remove('is-selected');
      });

      
      thumbnails.forEach(thmb => {
        thmb.setAttribute('aria-current', 'false');
      });

      
      mediaItems[index].classList.add('is-selected');
      thumbnail.setAttribute('aria-current', 'true');
    });
  });
});
}

document.addEventListener("DOMContentLoaded", () => {
  const PRODUCT_ID = "9870431584558";

  function updateOptions() {
    const picker = document.querySelector(
      `variant-picker[form-id*="product-form-${PRODUCT_ID}"]`
    );

    if (!picker) return;

    const sizeInputs = picker.querySelectorAll(
      'input[data-option-position="1"]'
    );

    const colorInputs = picker.querySelectorAll(
      'input[data-option-position="2"]'
    );

    let selectedSize = "";
    let selectedColor = "";

    sizeInputs.forEach((input) => {
      if (input.checked) {
        selectedSize = input.nextElementSibling.textContent.trim();
      }
    });

    colorInputs.forEach((input) => {
      if (input.checked) {
        selectedColor = input.nextElementSibling
          .querySelector(".sr-only").textContent.trim();
      }
    });

    [...sizeInputs, ...colorInputs].forEach((input) => {
      input.hidden = false;
      input.nextElementSibling.hidden = false;
    });

    if (selectedSize.startsWith("XL")) {
      colorInputs.forEach((input) => {
        const color = input.nextElementSibling
          .querySelector(".sr-only").textContent.trim();

        if (color === "Manta Ray" || color === "Dolphin") {
          input.hidden = true;
          input.nextElementSibling.hidden = true;
        }
      });
    }

    if (selectedColor === "Manta Ray" || selectedColor === "Dolphin") {
      sizeInputs.forEach((input) => {
        const size = input.nextElementSibling.textContent.trim();

        if (size.startsWith("XL")) {
          input.hidden = true;
          input.nextElementSibling.hidden = true;
        }
      });
    }
  }

  updateOptions();

  const observer = new MutationObserver(() => {
    updateOptions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const PRODUCT_ID = "9170723242286";

//   function updateOptions() {
//     const picker = document.querySelector(
//       `variant-picker[form-id*="product-form-${PRODUCT_ID}"]`
//     );

//     if (!picker) return;

//     const colorInputs = picker.querySelectorAll(
//       'input[data-option-position="2"]'
//     );

//     const hiddenColors = [
//       "Glacial Blue",
//       "Reef Green",
//     ];

//     colorInputs.forEach((input) => {
//       const label = input.nextElementSibling;

//       const color = (
//         label.querySelector(".sr-only")
//           ? label.querySelector(".sr-only").textContent
//           : label.textContent
//       )
//         .trim()
//         .replace(/\s+/g, " ");

//       const shouldHide = hiddenColors.includes(color);

//       input.hidden = shouldHide;
//       label.hidden = shouldHide;
//     });
//   }

//   updateOptions();

//   const observer = new MutationObserver(() => {
//     updateOptions();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const PRODUCT_ID = "9870431584558";

  function updateOptions() {
    const picker = document.querySelector(
      `variant-picker[form-id*="product-form-${PRODUCT_ID}"]`
    );

    if (!picker) return;

    const sizeInputs = picker.querySelectorAll(
      'input[data-option-position="1"]'
    );

    const colorInputs = picker.querySelectorAll(
      'input[data-option-position="2"]'
    );

    const isSG =
      (window.Shopify && Shopify.country === "SG") ||
      window.location.hostname.includes(".sg");

    let selectedSize = "";

    sizeInputs.forEach((input) => {
      if (input.checked) {
        selectedSize = input.nextElementSibling.textContent.trim();
      }
    });

    // Reset all options
    [...sizeInputs, ...colorInputs].forEach((input) => {
      input.hidden = false;
      input.nextElementSibling.hidden = false;
    });

    // Hide XL size in SG
    if (isSG) {
      sizeInputs.forEach((input) => {
        const size = input.nextElementSibling.textContent.trim();

        if (size.startsWith("XL")) {
          input.hidden = true;
          input.nextElementSibling.hidden = true;
        }
      });
    }

    let hiddenColors = [];

    // M | 12oz
    // if (selectedSize.startsWith("M")) {
    //   hiddenColors = [
    //     "Shark 20oz + NEW Leakproof Lid 2.0 for 20oz",
    //     "Octopus 20oz + NEW Leakproof Lid 2.0 for 20oz",
    //     "Shark 16oz + Black Hydrate+ Extension",
    //     "Octopus 16oz + Mousse Taupe Hydrate+ Extension",
    //     "Dolphin",
    //     "Manta Ray"
    //   ];

    //   if (isSG) {
    //     hiddenColors.push(
    //       "Dolphin",
    //       "Manta Ray"
    //     );
    //   }
    // }

    // // L | 16oz
    // else if (selectedSize.startsWith("L")) {
    //   hiddenColors = [
    //     "Shark 12oz + Coloured Lid (Blue)",
    //     "Octopus 12oz + Coloured Lid (Yellow)",
    //     "Shark 20oz + NEW Leakproof Lid 2.0 for 20oz",
    //     "Octopus 20oz + NEW Leakproof Lid 2.0 for 20oz",
    //     "Dolphin",
    //     "Manta Ray"
    //   ];

    //   if (isSG) {
    //     hiddenColors.push(
    //       "Shark 16oz + Black Hydrate+ Extension",
    //       "Dolphin",
    //       "Manta Ray"
    //     );
    //   }
    // }

    // XL | 20oz
    if (selectedSize.startsWith("XL")) {
      hiddenColors = [
        "Shark 12oz + Coloured Lid (Blue)",
        "Manta Ray",
        "Dolphin",
        "Octopus 12oz + Coloured Lid (Yellow)",
        "Shark 16oz + Black Hydrate+ Extension",
        "Octopus 16oz + Mousse Taupe Hydrate+ Extension"
      ];

      // if (isSG) {
      //   hiddenColors.push(
      //     "Shark 20oz + NEW Leakproof Lid 2.0 for 20oz",
      //     "Octopus 20oz + NEW Leakproof Lid 2.0 for 20oz",
      //     "Dolphin",
      //     "Manta Ray"
      //   );
      // }
    }

    const normalizedHiddenColors = hiddenColors.map((item) =>
      item.replace(/\s+/g, " ")
    );

    let selectedHidden = false;

    colorInputs.forEach((input) => {
      const label = input.nextElementSibling;

      // Works for both thumbnail swatches and block swatches
      const color = (
        label.querySelector(".sr-only")
          ? label.querySelector(".sr-only").textContent
          : label.textContent
      )
        .trim()
        .replace(/\s+/g, " ");

      const shouldHide = normalizedHiddenColors.includes(color);

      input.hidden = shouldHide;
      label.hidden = shouldHide;

      if (shouldHide && input.checked) {
        selectedHidden = true;
      }
    });

    // If the selected color became hidden, select the first visible one
    if (selectedHidden) {
      const firstVisible = [...colorInputs].find((input) => !input.hidden);

      if (firstVisible) {
        firstVisible.checked = true;

        firstVisible.dispatchEvent(
          new Event("change", {
            bubbles: true,
          })
        );
      }
    }
  }

  updateOptions();

  const observer = new MutationObserver(() => {
    updateOptions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});